import { useDispatch, useSelector } from '@redux';
import { confirmForcePayment } from '@redux/ordersExchange/actions';
import { Modal, Form, Input } from 'antd';
import FormItem from 'components/form/FormItem';
import { RestInputContext } from 'components/form/RestInputContext';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

interface IConfirmPaidModalProps {
  id?: string;
  visible?: boolean;
  onCancel?: () => void;
  exchangeId?: string;
}

const ConfirmPaidModal = ({
  id,
  visible,
  onCancel,
  exchangeId,
}: IConfirmPaidModalProps) => {
  const { t } = useTranslation();
  const loading = useSelector((state) => state.orders.loading);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    dispatch(
      confirmForcePayment({
        data: {
          id: id,
          exchangeId: exchangeId,
          data: values,
        },
        options: {
          isShowSuccessNoti: true,
        },
      }),
    ).then((res: DynamicObjectType) => {
      if (res?.payload?.success) {
        onCancel();
      }
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={() => {
        form.submit();
      }}
      okButtonProps={{
        loading,
      }}
      title={t('Confirm paid')}
    >
      <RestInputContext.Provider value={{ form }}>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <FormItem name="confirmPaidNote" label={t('orders.cancelNote')}>
            <Input.TextArea />
          </FormItem>
        </Form>
      </RestInputContext.Provider>
    </Modal>
  );
};

export default ConfirmPaidModal;
